var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":""}},[_c('v-card-title',[_vm._v(_vm._s(_vm.$t('title')))]),_vm._l((_vm.contacts),function(user){return _c('contact-person',{key:user.id,attrs:{"user":user}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }